module.exports = __webpack_public_path__ + "img/0242e5d.jpg";